module.exports = __webpack_public_path__ + "img/tiktok.56141cec.svg";